import React, { useEffect, useState, useCallback, useContext, useRef } from "react";
import api, { BASE_URL } from "../../Utils/api";
import { Modal, Form, Table, Pagination } from "react-bootstrap";
import { FaClock } from "react-icons/fa";
import TiposDocumentoModal from "./TiposDocumentoModal";
import ConfiguracoesCamposModal from "../Configuracoes/ConfiguracoesCampos/ConfiguracoesCamposModal";
import GruposAcessoTipoDocumentoModal from "./GruposAcessoTipoDocumentoModal";
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import { Salvar, Cancelar } from "../Generals/buttons";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../../Utils/GlobalContext";

const TIPOS_AGENDAMENTO_PER_PAGE = 10;


function TiposDocumento() {
  const { toast, confirm } = useFeedback();
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [selectedDocumento, setSelectedDocumento] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfigCamposModal, setShowConfigCamposModal] = useState(false);
  const [selectedTipoForConfig, setSelectedTipoForConfig] = useState(null);
  const [showGruposAcessoModal, setShowGruposAcessoModal] = useState(false);
  const [tipoDocumentoCriado, setTipoDocumentoCriado] = useState(null);

  // Modal: vincular tipos de agendamento
  const [showTiposAgendamentoModal, setShowTiposAgendamentoModal] = useState(false);
  const [selectedTipoParaAgendamento, setSelectedTipoParaAgendamento] = useState(null);
  const [tiposAgendamentoDisponiveis, setTiposAgendamentoDisponiveis] = useState([]);
  const [tiposAgendamentoSelecionados, setTiposAgendamentoSelecionados] = useState([]);
  const [searchTermTiposAgendamento, setSearchTermTiposAgendamento] = useState("");
  const [pageAtualTiposAgendamento, setPageAtualTiposAgendamento] = useState(1);
  const [tiposAgendamentoOriginais, setTiposAgendamentoOriginais] = useState([]);

  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  const token = localStorage.getItem("authToken");
  const exclusoesEmAndamento = useRef(new Set());
  const permiteEdicao = "S"; // Ajuste para "S" ou "N" , de Configurações ou Cadastros Globais de qualquer entidade

  const formatarMensagemErro = (message) =>
    typeof message === "string" ? message.replace(/\n+/g, " ").trim() : message;

  const resolverTipoConfiguracaoId = useCallback(async (idTipoDocumento) => {
    if (!entidadeID || !idTipoDocumento) return null;
    try {
      const { data } = await api.get(
        `${BASE_URL}/api/configuracaoCampos/ListarTiposConfiguracoesCampos/${entidadeID}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const lista = Array.isArray(data?.data) ? data.data : [];
      const match = lista.find((t) => Number(t.id_tipo_documento) === Number(idTipoDocumento));
      return match?.id ?? null;
    } catch (err) {
      console.error("Erro ao resolver id_tipo_configuracoes_campos:", err);
      return null;
    }
  }, [entidadeID, token]);

  // Definindo as colunas da tabela
  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Nome", accessor: "nome" },
    { Header: "Classificação", accessor: "classificacao_nome", Cell: ({ row }) => row.classificacao_nome || "—" },
    { Header: "Descrição", accessor: "descricao" },
    { Header: "Situação", accessor: "situacao" },
  ];

  // Função para buscar os tipos de documento
  const fetchTiposDocumento = useCallback(() => {
    api
      .get(`${BASE_URL}/api/tiposDocumento/ListarTiposDocumento/${entidadeID}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setTiposDocumentos(Array.isArray(response.data?.data) ? response.data.data : []);
      })
      .catch((error) => {
        console.error("Erro ao buscar os tipos de documentos:", error);
      });
  }, [token, entidadeID]);

  // Função para buscar os dados da API na montagem do componente
  useEffect(() => {
    fetchTiposDocumento();
  }, [fetchTiposDocumento]);

  const handleEdit = (documento) => {
    setSelectedDocumento(documento);
    setShowModal(true); // Abrir o modal para edição
  };

  const handleAdd = () => {
    setSelectedDocumento(null); // Limpar o documento selecionado para adicionar novo
    setShowModal(true); // Abrir o modal para novo documento
  };

  // Ao finalizar cadastro: abre ConfiguracoesCampos; ao fechar esse, abre GruposAcesso
  const handleClose = (createdTipo = null) => {
    setShowModal(false);
    setSelectedDocumento(null);
    const idTipoDocumento = createdTipo?.id ?? createdTipo?.id_tipo_documento ?? createdTipo?.tipoDocumentoId ?? (typeof createdTipo === "number" ? createdTipo : null);
    const idTipoConfiguracao = createdTipo?.id_tipo_configuracoes_campos ?? createdTipo?.tipoConfiguracaoId ?? createdTipo?.id_tipo_configuracao ?? null;
    if (idTipoDocumento != null) {
      setTipoDocumentoCriado({ id: idTipoDocumento, nome: createdTipo?.nome ?? "" });
      if (idTipoConfiguracao != null) {
        setSelectedTipoForConfig({ id: idTipoConfiguracao, id_tipo_documento: idTipoDocumento });
        setShowConfigCamposModal(true);
      } else {
        resolverTipoConfiguracaoId(idTipoDocumento).then((idConfig) => {
          if (idConfig != null) {
            setSelectedTipoForConfig({ id: idConfig, id_tipo_documento: idTipoDocumento });
            setShowConfigCamposModal(true);
          } else {
            fetchTiposDocumento();
          }
        });
      }
    }
  };

  const handleCloseConfigCamposEAbrirGrupos = () => {
    setShowConfigCamposModal(false);
    setSelectedTipoForConfig(null);
    if (tipoDocumentoCriado) {
      setShowGruposAcessoModal(true);
    }
  };

  const handleCloseGruposAcesso = () => {
    setShowGruposAcessoModal(false);
    setTipoDocumentoCriado(null);
    fetchTiposDocumento();
  };

  const handleExcluir = async (documento) => {
    if (exclusoesEmAndamento.current.has(documento.id)) return;
    exclusoesEmAndamento.current.add(documento.id);

    try {
      const ok = await confirm(`Tem certeza que deseja excluir o tipo "${documento.nome}"?`);
      if (!ok) return;

      await api.delete(
        `${BASE_URL}/api/tiposDocumento/ExcluirTiposDocumento/${documento.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchTiposDocumento();
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error(
          formatarMensagemErro(error.response.data?.message) ||
            "Este tipo de documento está sendo utilizado."
        );
        return;
      }

      console.error("Erro ao excluir tipo de documento:", error);
      toast.error(
        formatarMensagemErro(error.response?.data?.message) || "Erro ao excluir. Tente novamente."
      );
    } finally {
      exclusoesEmAndamento.current.delete(documento.id);
    }
  };

  // Configuração na coluna Ação: modal carrega via GET configuracaoCampos/ListarConfiguracoesCamposPorTipoDocumentos/:idTipoDocumento (ex.: .../1038)
  const handleOpenConfigCampos = async (tipoDocumento) => {
    const idTipoDocumento = tipoDocumento?.id;
    const idConfig = await resolverTipoConfiguracaoId(idTipoDocumento);
    if (idConfig != null) {
      setSelectedTipoForConfig({ ...tipoDocumento, id: idConfig, id_tipo_documento: idTipoDocumento });
      setShowConfigCamposModal(true);
    } else {
      toast.error("Configuração de campos não encontrada para este tipo de documento.");
    }
  };

  // Fechamento via botão fechar/cancelar no modal de config de campos (sem fluxo de criação)
  const handleCloseConfigCampos = () => {
    setShowConfigCamposModal(false);
    setSelectedTipoForConfig(null);
    setTipoDocumentoCriado(null);
  };

  // ---- Vincular Tipos de Agendamento ----
  const handleOpenTiposAgendamentoModal = async (tipoDocumento) => {
    setSelectedTipoParaAgendamento(tipoDocumento);
    setSearchTermTiposAgendamento("");
    setPageAtualTiposAgendamento(1);
    setTiposAgendamentoSelecionados([]);
    setShowTiposAgendamentoModal(true);
    try {
      const [dispResp, vincResp] = await Promise.all([
        api.get(`${BASE_URL}/api/tiposAgendamentos/ListarTiposAgendamento/${entidadeID}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        api.get(`${BASE_URL}/api/tiposDocumento/ListarTipoDocumentoTiposAgendamento/${tipoDocumento.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      const selecionados = Array.isArray(vincResp.data?.data) ? vincResp.data.data.map((r) => r.id_tipo_agendamento) : [];
      setTiposAgendamentoDisponiveis(Array.isArray(dispResp.data?.data) ? dispResp.data.data : []);
      setTiposAgendamentoSelecionados(selecionados);
      setTiposAgendamentoOriginais(selecionados);
    } catch (err) {
      console.error("Erro ao carregar tipos de agendamento:", err);
    }
  };

  const handleTipoAgendamentoClick = (id) => {
    setTiposAgendamentoSelecionados((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSaveTiposAgendamento = async () => {
    try {
      await api.put(
        `${BASE_URL}/api/tiposDocumento/EditarTipoDocumentoTiposAgendamento/${selectedTipoParaAgendamento.id}`,
        { tipos_agendamento: tiposAgendamentoSelecionados },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const adicionados = tiposAgendamentoSelecionados.filter((id) => !tiposAgendamentoOriginais.includes(id));
      const removidos = tiposAgendamentoOriginais.filter((id) => !tiposAgendamentoSelecionados.includes(id));

      setShowTiposAgendamentoModal(false);

      if (adicionados.length > 0) {
        await api.put(
          `${BASE_URL}/api/tiposDocumento/VincularAgendamentosAosDocumentos/${selectedTipoParaAgendamento.id}`,
          { tipos_agendamento: adicionados },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      if (removidos.length > 0) {
        await api.delete(
          `${BASE_URL}/api/tiposDocumento/DesvincularAgendamentosDoDocumentos/${selectedTipoParaAgendamento.id}`,
          { data: { tipos_agendamento: removidos }, headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (err) {
      console.error("Erro ao salvar vínculos:", err);
      toast.error(formatarMensagemErro(err.response?.data?.message) || "Erro ao salvar. Tente novamente.");
    }
  };

  const getDescricaoPeriodicidade = (p) => {
    switch (p) {
      case "D":  return "Diário";
      case "S":  return "Semanal";
      case "M":  return "Mensal";
      case "A":  return "Anual";
      case "V":  return "Dias Antes do Vencimento";
      case "VD": return "Dias Antes do Vencimento (Pelo Documento)";
      default:   return "Outro";
    }
  };

  return (
    <div>
      <PageHeader titulo="Cadastro de Tipos de Documento" path="/TiposDocumento" />

      <GridPadrao
        columns={columns}
        data={tiposDocumentos}
        onEdit={(configuracao) => handleEdit(configuracao, permiteEdicao)}
        onAdd={handleAdd}
        addDataTour="tipos-documento-adicionar"
        onInactivate={handleExcluir}
        onConfigCampos={handleOpenConfigCampos}
        configCamposDataTour="tipos-documento-config-campos"
        onAcao={handleOpenTiposAgendamentoModal}
        acaoDataTour="tipos-documento-vincular-agendamento"
        AcaoIcone={FaClock}
        acaoTitulo="Vincular Tipos de Agendamento"
        acaoVariant="outline-secondary"
      />

      <TiposDocumentoModal
        show={showModal}
        handleClose={handleClose}
        documento={selectedDocumento}
        idEntidade={entidadeID}
        fetchTiposDocumento={fetchTiposDocumento}
        onVincularAgendamento={handleOpenTiposAgendamentoModal}
      />

      <ConfiguracoesCamposModal
        show={showConfigCamposModal}
        handleClose={tipoDocumentoCriado ? handleCloseConfigCamposEAbrirGrupos : handleCloseConfigCampos}
        configuracao={selectedTipoForConfig}
        fetchConfiguracoes={fetchTiposDocumento}
      />

      <GruposAcessoTipoDocumentoModal
        show={showGruposAcessoModal}
        handleClose={handleCloseGruposAcesso}
        idTipoDocumento={tipoDocumentoCriado?.id}
        nomeTipoDocumento={tipoDocumentoCriado?.nome}
        idEntidade={entidadeID}
      />

      {/* Modal: vincular tipos de agendamento ao tipo de documento */}
      <Modal
        show={showTiposAgendamentoModal}
        onHide={() => setShowTiposAgendamentoModal(false)}
        dialogClassName="modal-dialog-top"
        size="lg"
      >
        <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
          <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
            Vincular Tipos de Agendamento
            {selectedTipoParaAgendamento && (
              <span style={{ display: "block", fontSize: "0.82rem", fontWeight: 400, color: "var(--text-muted)", marginTop: 2 }}>
                {selectedTipoParaAgendamento.nome}
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
          {(() => {
            const listaTiposAtivos = tiposAgendamentoDisponiveis.filter((a) => a.situacao === "A");
            const termo = (searchTermTiposAgendamento || "").trim().toLowerCase();
            const listaTiposFiltrada = termo
              ? listaTiposAtivos.filter(
                  (a) =>
                    (a.nome || "").toLowerCase().includes(termo) ||
                    (a.descricao || "").toLowerCase().includes(termo)
                )
              : listaTiposAtivos;
            const totalRecords = listaTiposFiltrada.length;
            const totalPages = Math.ceil(totalRecords / TIPOS_AGENDAMENTO_PER_PAGE) || 1;
            const startRecord = totalRecords === 0 ? 0 : (pageAtualTiposAgendamento - 1) * TIPOS_AGENDAMENTO_PER_PAGE + 1;
            const endRecord = Math.min(pageAtualTiposAgendamento * TIPOS_AGENDAMENTO_PER_PAGE, totalRecords);
            const inicio = (pageAtualTiposAgendamento - 1) * TIPOS_AGENDAMENTO_PER_PAGE;
            const tiposPagina = listaTiposFiltrada.slice(inicio, inicio + TIPOS_AGENDAMENTO_PER_PAGE);

            return (
              <>
                <Form.Group controlId="searchTiposAgendamentoTD" className="mb-3">
                  <Form.Label>Pesquisar Tipos de Agendamento</Form.Label>
                  <Form.Control
                    type="text"
                    value={searchTermTiposAgendamento}
                    placeholder="Digite para pesquisar..."
                    onChange={(e) => {
                      setSearchTermTiposAgendamento(e.target.value);
                      setPageAtualTiposAgendamento(1);
                    }}
                  />
                </Form.Group>
                <div style={{ maxHeight: "400px", overflowY: "auto", padding: "12px 4px" }} className="mb-3">
                  {tiposPagina.length === 0 ? (
                    <p className="text-muted text-center py-4">Nenhum tipo de agendamento encontrado.</p>
                  ) : (
                    <Table hover size="sm" responsive className="mb-0 align-middle">
                      <thead>
                        <tr>
                          <th style={{ width: "80px", textAlign: "center", fontSize: "var(--text-xs)", textTransform: "uppercase", letterSpacing: "var(--tracking-caps)", color: "var(--table-head-text)", fontWeight: 700, borderTop: "none" }}>Selecionar</th>
                          <th style={{ fontSize: "var(--text-xs)", textTransform: "uppercase", letterSpacing: "var(--tracking-caps)", color: "var(--table-head-text)", fontWeight: 700, borderTop: "none" }}>Nome</th>
                          <th style={{ fontSize: "var(--text-xs)", textTransform: "uppercase", letterSpacing: "var(--tracking-caps)", color: "var(--table-head-text)", fontWeight: 700, borderTop: "none" }}>Descrição / Periodicidade</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tiposPagina.map((ta) => (
                          <tr key={ta.id}>
                            <td className="align-middle text-center">
                              <Form.Check
                                type="switch"
                                id={`ta-td-${ta.id}`}
                                checked={tiposAgendamentoSelecionados.includes(ta.id)}
                                onChange={() => handleTipoAgendamentoClick(ta.id)}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                            <td
                              className="align-middle"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleTipoAgendamentoClick(ta.id)}
                            >
                              <strong>{ta.nome}</strong>
                            </td>
                            <td
                              className="align-middle"
                              style={{ cursor: "pointer", fontSize: "0.9rem" }}
                              onClick={() => handleTipoAgendamentoClick(ta.id)}
                            >
                              {ta.descricao && <span>{ta.descricao}</span>}
                              {ta.descricao && <br />}
                              <span className="text-muted">
                                {getDescricaoPeriodicidade(ta.periodicidade)}
                                {" - "}
                                {ta.horario || "08:00"}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    {totalRecords > 0 && (
                      <span className="text-muted small">
                        Mostrando {startRecord} a {endRecord} de {totalRecords} registros
                      </span>
                    )}
                  </div>
                  {totalPages > 1 && (
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First onClick={() => setPageAtualTiposAgendamento(1)} disabled={pageAtualTiposAgendamento === 1} />
                      <Pagination.Prev onClick={() => setPageAtualTiposAgendamento((p) => p - 1)} disabled={pageAtualTiposAgendamento === 1} />
                      {[...Array(totalPages)].map((_, i) => {
                        const pageNum = i + 1;
                        if (
                          pageNum === 1 ||
                          pageNum === totalPages ||
                          (pageNum >= pageAtualTiposAgendamento - 1 && pageNum <= pageAtualTiposAgendamento + 1)
                        ) {
                          return (
                            <Pagination.Item
                              key={pageNum}
                              active={pageNum === pageAtualTiposAgendamento}
                              onClick={() => setPageAtualTiposAgendamento(pageNum)}
                            >
                              {pageNum}
                            </Pagination.Item>
                          );
                        }
                        if (pageNum === 2 && pageAtualTiposAgendamento > 3)
                          return <Pagination.Ellipsis key="el-s" disabled />;
                        if (pageNum === totalPages - 1 && pageAtualTiposAgendamento < totalPages - 2)
                          return <Pagination.Ellipsis key="el-e" disabled />;
                        return null;
                      })}
                      <Pagination.Next onClick={() => setPageAtualTiposAgendamento((p) => p + 1)} disabled={pageAtualTiposAgendamento === totalPages} />
                      <Pagination.Last onClick={() => setPageAtualTiposAgendamento(totalPages)} disabled={pageAtualTiposAgendamento === totalPages} />
                    </Pagination>
                  )}
                </div>
              </>
            );
          })()}
        </Modal.Body>
        <Modal.Footer className="modal-footer-padrao">
          <div className="modal-footer-acoes-esquerda" />
          <div className="modal-footer-acoes-direita">
            <Cancelar onClick={() => setShowTiposAgendamentoModal(false)} />
            <Salvar onClick={handleSaveTiposAgendamento} title="Salvar Vínculos" />
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default TiposDocumento;